import React from 'react'
import PropTypes from "prop-types";
import { Row, Col, Card, Button } from 'antd';
import { translate } from 'react-i18next'

const UpsellPackage = ({ t, isHaveRecords }) => {
  return (
    <div className="record-upsell">
      <Card>
        <Row>
          <Col span={6} className="upsell-icon">
            <img alt="vroom package" src="/portal/img/vroom-package.png" />
          </Col>
          <Col span={18} className="content">
            <span>{t('my_record.upsell_upgrade_package')}</span><br />
            <span>{t('my_record.upsell_upgrade_package2')} </span> { isHaveRecords ? <span>{t('my_record.upsell_again')}</span> : null}
            <br />
            <div className="red-line"></div>
            <Button className="upsell-btn" onClick={() => window.location = '/portal/subscription/planspricing/'}>{t('my_record.upsell_choose_plan')}</Button>
          </Col>
        </Row>
      </Card>
    </div> 
  )
}

UpsellPackage.propTypes = {
  isHaveRecords: PropTypes.bool
}

UpsellPackage.defaultProps = {
  isHaveRecords: false
}

export default translate()(UpsellPackage)
